/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionsControllerUpdateMutationRequest, TemplateQuestionsControllerUpdateMutationResponse, TemplateQuestionsControllerUpdatePathParams, TemplateQuestionsControllerUpdate400, TemplateQuestionsControllerUpdate401, TemplateQuestionsControllerUpdate403, TemplateQuestionsControllerUpdate404 } from "../../models/checklistsController/TemplateQuestionsControllerUpdate";

function getTemplateQuestionsControllerUpdateUrl(id: TemplateQuestionsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/checklist-template-questions/${id}` as const }  
  return res
}

/**
 * @summary Update a checklist template question
 * {@link /api/v1/checklist-template-questions/:id}
 */
export async function templateQuestionsControllerUpdate(id: TemplateQuestionsControllerUpdatePathParams["id"], data?: TemplateQuestionsControllerUpdateMutationRequest, config: Partial<RequestConfig<TemplateQuestionsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplateQuestionsControllerUpdateMutationResponse, ResponseErrorConfig<TemplateQuestionsControllerUpdate400 | TemplateQuestionsControllerUpdate401 | TemplateQuestionsControllerUpdate403 | TemplateQuestionsControllerUpdate404>, TemplateQuestionsControllerUpdateMutationRequest>({ method : "PATCH", url : getTemplateQuestionsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}